import rangePicker from './range-picker.vue'

rangePicker.install = function(Vue) {
  Vue.component(rangePicker.name, rangePicker)
}

export default rangePicker
